import { have_attr_carrying, orderTypeMount, setCod, setCodAmount2 } from "../helpers/OrdersFunctionsGlobal";
import { ruleCarrying } from "../helpers/ShipmentRules";
import { returnToOffice } from "../helpers/Utils";

const setOrderInitialValue = (order = {}, additionals = {}) => {
    // additionals.pickup_addresses
    // additionals.order_rows
    const { order_type, delivery } = orderTypeMount(
        order.carrier,
        order.shipping_address.parcel_terminal_id
    );

    const order_rows = additionals.order_rows || order.order_rows || []
    // console.log("order data: => ", { order, additionals })
    // console.log('cod_amount: ', setCodAmount2({
    //     waiting_payments: additionals.waiting_payments || order.waiting_payments || [],
    //     order_rows,
    //     shipments: additionals.shipments || order.shipments || [],
    //     orderInfo: order,
    //     order_cart_rules: additionals.order_cart_rules || order.order_cart_rules || [],
    // }))
    let stateObj = {
        id: order.id,
        order_type,
        cod: setCod({
            cod: order.cod,
            leasing_cod: order.leasing_cod,
            shipment_type: order_type,
            payment_module: order.payment_module,
        }),
        cod_amount: setCodAmount2({
            waiting_payments: additionals.waiting_payments || order.waiting_payments || [],
            order_rows,
            shipments: additionals.shipments || order.shipments || [],
            orderInfo: order,
            order_cart_rules: additionals.order_cart_rules || order.order_cart_rules || [],
        }).price,
        delivery,
        carrying: ruleCarrying({
            order_type,
            delivery,
        })
            ? have_attr_carrying(order_rows)
            : false,
        shipping_address_edit:
            order_type === "at_the_store"
                ? {
                    ...returnToOffice(order, additionals.pickup_addresses || []),
                    comment: order.remark || "",
                }
                : {
                    ...order.shipping_address,
                    postal_code:
                        order_type == "dpd" || order_type == "venipak"
                            ? order.shipping_address.postal_code?.replace(/lv-/gi, "")
                            : order.shipping_address.postal_code,
                    comment: order.remark || "",
                },
        terminalSelected: order.shipping_address.parcel_terminal_id,
    };
    return stateObj;
}

export {
    setOrderInitialValue
}